import { render, staticRenderFns } from "./InvoiceAdjustReport.vue?vue&type=template&id=687d8a96"
import script from "./InvoiceAdjustReport.vue?vue&type=script&lang=js"
export * from "./InvoiceAdjustReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports